module.exports = __webpack_public_path__ + "media/images/hotel-icon-web-c50dc7df5ae235c094338c4cce98fbef.png";